import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import { api } from "../api/client";
import VenueCard from "../components/VenueCard";

export default function Venues() {
  const [params, setParams] = useSearchParams();
  const [venues, setVenues] = useState([]);
  const [q, setQ] = useState(params.get("q") || "");
  const type = params.get("type") || "all";

  useEffect(() => {
    const query = new URLSearchParams();
    if (type && type !== "all") query.set("type", type);
    if (params.get("q")) query.set("q", params.get("q"));
    api(`/api/venues?${query.toString()}`)
      .then(setVenues)
      .catch(() => setVenues([]));
  }, [type, params]);

  const cities = useMemo(
    () => [...new Set(venues.map((v) => v.city))].sort(),
    [venues]
  );

  function setType(next) {
    const copy = new URLSearchParams(params);
    if (next === "all") copy.delete("type");
    else copy.set("type", next);
    setParams(copy);
  }

  function onSearch(event) {
    event.preventDefault();
    const copy = new URLSearchParams(params);
    if (q.trim()) copy.set("q", q.trim());
    else copy.delete("q");
    setParams(copy);
  }

  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
      <p className="text-xs uppercase tracking-[0.22em] text-rose">The house list</p>
      <h1 className="mt-2 font-serif text-5xl">Every Aurelia page</h1>
      <p className="mt-3 max-w-2xl text-ink/65">
        Each hotel owner keeps a living page — rooms, halls, packages and a
        booking desk of their own.
      </p>

      <form
        onSubmit={onSearch}
        className="mt-8 flex flex-col gap-3 rounded-[1.8rem] bg-white/80 p-3 shadow-card sm:flex-row sm:items-center"
      >
        <div className="relative flex-1">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-ink/35" size={16} />
          <input
            className="field pl-11"
            placeholder="Search a city, hall or hotel…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
        </div>
        <button className="btn-ink" type="submit">
          Search
        </button>
      </form>

      <div className="mt-6 flex flex-wrap gap-2">
        {[
          ["all", "All"],
          ["hotel", "Hotels"],
          ["wedding-hall", "Wedding halls"],
        ].map(([value, label]) => (
          <button
            key={value}
            onClick={() => setType(value)}
            className={`chip ${
              type === value ? "bg-ink text-cream" : "bg-white text-ink/70"
            }`}
          >
            {label}
          </button>
        ))}
        {cities.map((city) => (
          <span key={city} className="chip bg-blush/60 text-plum">
            {city}
          </span>
        ))}
      </div>

      <div className="mt-10 grid gap-6 sm:grid-cols-2 xl:grid-cols-3">
        {venues.map((venue) => (
          <VenueCard key={venue.id} venue={venue} />
        ))}
      </div>
      {!venues.length && (
        <p className="mt-16 text-center text-ink/50">No published venues match yet.</p>
      )}
    </div>
  );
}
